module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('shop-select', {
    attrs: {
      "distributors": ""
    },
    on: {
      "update": _vm.storeChange,
      "init": _vm.initChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "公告内容",
      "clearable": ""
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加公告")])], 1)], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "公告列表",
      "name": "admin"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "distributor_notice_id",
      "label": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_publish",
      "label": "是否公布"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.is_publish === 0 ? 'primary' : 'success',
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.is_publish == 0 ? '未公布' : '已公布'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor_name",
      "label": "所属店铺"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.distributor_name === '' ? 'primary' : 'warning',
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.distributor_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sort",
      "label": "排序"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "公告类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.type === 0 ? 'primary' : 'success',
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.type == 0 ? '全部' : '指定'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "message",
      "label": "公告内容"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.handleUpdate(scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加/编辑公告",
      "visible": _vm.dialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属店铺"
    }
  }, [_c('shop-select', {
    attrs: {
      "distributors": "",
      "shopIdDefault": _vm.DistributorName
    },
    on: {
      "update": _vm.addSelectStoreChange,
      "init": _vm.initChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公告内容"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入公告内容,不超过200字"
    },
    model: {
      value: (_vm.form.message),
      callback: function($$v) {
        _vm.$set(_vm.form, "message", $$v)
      },
      expression: "form.message"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入数字"
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否公布"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_publish),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_publish", $$v)
      },
      expression: "form.is_publish"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否指定店铺"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29f30b8e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29f30b8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/distributornotice.vue
// module id = 2561
// module chunks = 0